import PurchaseOrderClient from "./clients/PurchaseOrderClient";
import ShipmentsClient from "./clients/ShipmentsClient";

const purchaseOrderPath = "purchaseOrder";
const ShipmentPath = "trazabilidad";

export default {
  getPO(id, user, lang = "MX") {
    return PurchaseOrderClient.get(
      `${purchaseOrderPath}/purchaseOrderInfo/${id}?user=${user}&lang=${lang}`
    );
  },
  getPOItems(id, body) {
    return PurchaseOrderClient.post(
      `${purchaseOrderPath}/purchaseOrderItems/${id}`, body
    );
  },
  getPOComments(id, moduleId, timezone, lang = "MX") {
    return PurchaseOrderClient.get(
      `${purchaseOrderPath}/purchaseOrderComments/get-comment?rowid=${id}&moduleid=${moduleId}&general=true&zona=${timezone}&lang=${lang}`
    );
  },
  getPOEvents(id, lang = "MX") {
    return PurchaseOrderClient.get(
      `${purchaseOrderPath}/poEvents/${id}?lang=${lang}`
    );
  },
  createComment(data) {
    return PurchaseOrderClient.post("purchaseOrderComments/add-comment", data);
  },
  deleteComment(id) {
    return PurchaseOrderClient.delete(
      `purchaseOrderComments/delete-comment/${id}`
    );
  },
  filterCatalogs(data) {
    return PurchaseOrderClient.post(`${purchaseOrderPath}/filterCatalog`, data);
  },
  getGraphic(data) {
    return PurchaseOrderClient.post(`${purchaseOrderPath}/graphicList`, data);
  },
  getOrders(data) {
    return PurchaseOrderClient.post(
      `${purchaseOrderPath}/listPurchaseOrders`,
      data
    );
  },
  updatePO(data) {
    return PurchaseOrderClient.put(
      `${purchaseOrderPath}/purchaseOrderInfo`,
      data
    );
  },
  updatePOCustomerEntities(data) {
    return PurchaseOrderClient.put(
      `${purchaseOrderPath}/purchaseOrderCustomerEntities`,
      data
    );
  },
  updatePOItem(data) {
    return PurchaseOrderClient.put(
      `${purchaseOrderPath}/purchaseOrderItems`,
      data
    );
  },
  getCatalogs(lang) {
    return PurchaseOrderClient.get(`${purchaseOrderPath}/getCatalogs${lang ? `?lang=${lang}` : ''}`);
  },
  updatePOItemStatus(data) {
    return PurchaseOrderClient.post(
      `${purchaseOrderPath}/updatePOItemsStatus`,
      data
    );
  },
  massivePOItemsUpdate(data) {
    return PurchaseOrderClient.post(
      `${purchaseOrderPath}/massiveUpdatePOItems`,
      data
    );
  },
  parcedPOItems(data) {
    return PurchaseOrderClient.post(
      `${purchaseOrderPath}/parcedPOItems`,
      data
    );
  },
  getOrdersByShipment(data) {
    return PurchaseOrderClient.post(
      `${purchaseOrderPath}/getPOByShipments`,
      data
    );
  },

  getOrdersShipmentShare(data, token) {
    return PurchaseOrderClient.post(
      `${purchaseOrderPath}/get-pos-shipment-share`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  },

  getDocuments(data) {
    return ShipmentsClient.post(
      `${ShipmentPath}/get-documents`,
      data
    );
  },

  getOrdersShipmentPublic(id) {
    return PurchaseOrderClient.get(
      `${purchaseOrderPath}/get-pos-shipment-public/${id}`);
  },
};
